import { compose, hoistStatics, withState, withPropsOnChange, withHandlers } from 'recompose';
import { translate } from 'react-i18next';
import Editor from './Editor';
import ImageService from '../../../services/image.service';  


const pasteImage = props => async (image) => {
  
  const laptopNewImage = ImageService.getImage(image.image, 1100, 1100)
  const mobileNewImage = ImageService.getImage(image.image, 350, 350)
  const webpLaptopNewImage = laptopNewImage + '.webp'
  const webpMobileNewImage = mobileNewImage + '.webp'
  const originalNewImage = ImageService.getImage(image.image)

  const newImage = `
  <a href="${originalNewImage}">
  <picture>
  <source srcset="${webpMobileNewImage}" media="(max-width: 578px)" type="image/webp">
  <source srcset="${webpLaptopNewImage}" media="(min-width: 579px)" type="image/webp">
  <source srcset=${mobileNewImage} media="(max-width: 578px)">
  <img src="${originalNewImage}" alt="${image.alt}"/>
  </picture>
  </a>`
  
  const newContent = props.content.slice(0, props.quillCursorPosition) + newImage + props.content.slice(props.quillCursorPosition);
  props.setValue(newContent)
  props.setModalOpen(false)
};

const enhance = compose(
  translate('core'),
  withState('content', 'setContent', ''),
  withState('modalOpen', 'setModalOpen', ''),
  withState('quillCursorPosition', 'setQuillCursorPosition', 0),
  withPropsOnChange(['content'], props => {
    if (props.value !== props.content) {
      props.setValue(props.content);
    }
  }),
  withPropsOnChange(['value'], props => {
    if (props.value !== props.content) {
      props.setContent(props.value);
    }
  }),
  withHandlers({
    pasteImage
  })
);

export default hoistStatics(enhance)(Editor);



// WEBPACK FOOTER //
// ./src/components/cms/editor/index.js